<template>
  <div :class="[{ 'page-default': isDefault() }, { 'child-hover': childHovering }]" @mouseenter="checkHover" @mouseleave="checkLeave">
    <!-- <img :src="publicPath + require('@/core/assets/gif/makeDefaultProduct.gif')" class="hide" /> -->
    <component :is="isOriginalShopifyPage || isRunningAbTesting ? 'div' : 'a'" :href="isOriginalShopifyPage || isRunningAbTesting || listType == 'addPages' ? null : page.editUrl" class="col align-self-stretch d-flex" @[eventHandler]="openEditor">
      <div class="row">
        <div class="page-item-info d-flex align-items-center">
          <div class="page-item-info-image">
            <img v-if="isOriginalShopifyPage || page.isGpTemplate == false || page.gp_unlink == true" :src="publicPath + require('@/core/assets/Shopify.jpg')" />
            <img v-else-if="page.thumbnail_url && page.thumbnail_url > ''" :src="getThumbnail(page.thumbnail_url)" @error="imageLoadOnError" />
            <img v-else :src="publicPath + require('@/core/assets/ThumbnailPlaceholder.jpg')" />
          </div>
          <div class="page-item-info-body ml-2" :class="{ 'd-flex align-items-center': listType == 'productCollectionPages' && !isDisplayAssignedText && !isOriginalShopifyPage && !isRunningAbTesting && isOpenRightSection }">
            <div class="d-flex align-items-center">
              <!-- Page title -->
              <div class="page-item-info-body-title mr-1 d-flex align-items-center">
                <div v-if="titleTooltip && isEllipsisTitleActive" class="tool-tip d-flex align-items-center" :class="{ 'side-bar-truncate': isOpenRightSection }">
                  <span class="tool-tip-value typo-medium">{{ titlePage }}</span>
                </div>
                <p class="typo-heading16 typo-medium text-ligh-high" ref="title" :class="{ 'side-bar-truncate': isOpenRightSection, 'running-campaign': isRunningAbTesting }" @mouseenter="titleTooltip = true" @mouseleave="titleTooltip = false">
                  {{ titlePage }}
                </p>
              </div>

              <!-- Status tag -->
              <div class="page-item-info-body-status mr-1" :class="pageStatusClass" v-if="pageStatus">
                <p class="typo-paragraph12 typo-medium">{{ pageStatus }}</p>
              </div>
              <div v-if="isRunningAbTesting" class="page-item-info-body-status campaign" @mouseenter="campaignTooltip = true" @mouseleave="campaignTooltip = false">
                <div v-if="campaignTooltip" class="tool-tip tool-tip-campaign d-flex align-items-center" :class="{ 'side-bar-truncate': isOpenRightSection }">
                  <span class="tool-tip-value typo-regular">{{ $t("page.campaign.tooltip") }}</span>
                </div>
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.campaign") }}</p>
              </div>
              <div v-else-if="isPublishScheduled && ['productpages', 'collectionpages', 'homepages'].includes(pageType)" class="page-item-info-body-status schedule">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.scheduled") }}</p>
              </div>
              <div v-else-if="isNeedRepublishing && ['productpages', 'collectionpages', 'homepages'].includes(pageType)" class="page-item-info-body-status need-publish">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.outdated") }}</p>
              </div>
              <div v-else-if="!page.is_published && !isOriginalShopifyPage && ['productpages', 'collectionpages', 'homepages'].includes(pageType)" class="page-item-info-body-status draft">
                <p class="typo-paragraph12 typo-medium">{{ $t("page.status.draft") }}</p>
              </div>
            </div>

            <!-- Description section -->
            <div v-if="isRunningAbTesting" class="page-item-info-body-desc d-flex align-items-center">
              <div class="ab-description d-flex align-items-center">
                <div v-if="campaignDescTooltip" class="tool-tip tool-tip-ab-description d-flex align-items-center" :class="{ 'side-bar-truncate': isOpenRightSection }">
                  <span class="tool-tip-value typo-medium">{{ $t("page.campaign.warning") }}</span>
                </div>
                <p class="ab-description-text typo-paragraph12 typo-regular" ref="ab" :class="{ 'side-bar-truncate': isOpenRightSection, 'is-tooltip': campaignDescTooltip }" @mouseenter="checkHoverTruncateABTestDesc" @mouseleave="campaignDescTooltip = false">
                  {{ $t("page.campaign.warning") }}
                </p>
              </div>
              <a :href="`/analytics/experiments/${page.runningCampaignId}`" @click.stop class="open-campaign typo-paragraph12 typo-medium ml-half">{{ $t("page.campaign.action") }}</a>
            </div>

            <div class="page-item-info-body-desc d-flex align-items-center justify-content-start typo-paragraph12" v-else>
              <!-- Group name -->
              <div class="page-item-info-body-group d-flex align-items-center" v-if="groupName" @mouseenter="groupTooltip = true" @mouseleave="groupTooltip = false">
                <div v-if="groupTooltip && isTruncateGroupName" class="tool-tip tool-tip-group d-flex align-items-center" :class="{ 'side-bar-truncate': isOpenRightSection }">
                  <span class="tool-tip-value typo-regular">{{ groupName }}</span>
                </div>
                <div class="d-flex align-tems-center">
                  <i class="icon icon-group typo-icon-12 text-light-low mr-1"></i>
                  <p class="page-item-info-body-group-name" ref="group" :class="{ disabledTruncate: !isTruncateGroupName }">
                    {{ groupName }}
                  </p>
                </div>
              </div>

              <!-- Assign {n} product | collection -->
              <div class="page-item-info-body-assign d-flex align-items-center" :class="{ disabledSeperator: isOpenRightSection }" v-if="isDisplayAssignedText">
                <p class="typo-paragraph12 typo-regular text-light-low">{{ itemCount }}</p>
                <div class="assigned-default-help d-flex align-items-center" v-if="isDefault()" @mouseenter="assigedDefaultTooltip = true" @mouseleave="assigedDefaultTooltip = false">
                  <div v-if="assigedDefaultTooltip" class="tool-tip tool-tip-assigned-default d-flex align-items-center">
                    <span class="tool-tip-value typo-regular">{{ assignedTooltipText }}</span>
                  </div>
                  <i class="icon icon-help typo-regular text-light-low ml-half mr-half"></i>
                </div>
              </div>

              <!-- Scheduled Published at -->
              <div class="page-item-info-body-scheduled-publish d-flex align-items-center" :class="{ disabledSeperator: page.published && !isModifiedAt }" v-if="isPublishScheduled && !isOpenRightSection">
                <p class="page-item-info-body-scheduled-publish-at d-flex">{{ schedulePublishAt }}</p>
              </div>

              <!-- Modified at -->
              <div class="page-item-info-body-modified d-flex align-items-center" v-if="isModifiedAt">
                <p class="page-item-info-body-modified-at typo-paragraph12 typo-regular text-ligh-low d-flex" v-if="!isOriginalShopifyPage">
                  <span v-html="authorText.text" :class="authorText.class" v-if="page.gp_unlink"></span>
                  {{ $t("page.sort.modified") }} {{ timeago }}
                </p>
              </div>

              <!-- Published at -->
              <div class="page-item-info-body-publish d-flex align-items-center">
                <p class="page-item-info-body-publish-at d-flex" v-if="['subpages', 'articlepages'].includes(pageType) && page.published_at && page.published && !isNeedRepublishing && !isPublishScheduled">{{ $t("generals.published") }} {{ publishAgo }}</p>
              </div>

              <!-- Other description (Eg: original product page) -->
              <div class="page-item-info-body-desc-page d-flex align-items-center">
                <p class="typo-paragraph12 typo-regular text-ligh-low">{{ descPage }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </component>
    <!-- Make default | Assign Product/Collection button -->
    <div class="align-self-stretch d-flex justify-content-center product-collection-assign clickable pr-half pr-xl-0 mr-1" v-if="listType != 'addPages'">
      <div class="page-item-tools-status d-flex align-items-center" v-if="layoutDefaultStatus()">
        <p v-if="listType == 'productCollectionPages'" @click.stop="openAssignSection" class="typo-button14 typo-medium page-item-tools-status-button d-block assign-product">
          {{ isOpenRightSection ? "Assign" : `Assign ${pageType == "productpages" ? "Products" : "Collections"}` }}
        </p>
        <p v-else @click.stop="() => openModal()" v-popover:tooltip.bottom="makeDefaultTooltip" class="typo-button14 typo-medium page-item-tools-status-button d-block" :class="{ 'make-default': canMakeDefault(), typo_cGreen: isDefault(), 'no-hover default-page': isDefault(), 'is-running-campaign': isRunningAbTesting }">{{ defaultText }}</p>
      </div>
    </div>
    <!-- Preview, options -->
    <div class="d-flex flex-row-reverse p-0" v-if="listType != 'addPages'">
      <div class="page-item-tools d-flex">
        <div class="page-item-tools-mini">
          <div class="page-item-tools-mini-dropdown">
            <PageItemDropdown :total="total" :page="page" :pageType="pageType" :whereAmI="whereAmI" :pageDefaultTitle="pageDefaultTitle" @onReLoadSearch="onReLoadSearch" @onMakeDefault="onMakeDefault" @preventOpenEditor="preventOpenEditor" />
          </div>
        </div>
      </div>
      <div class="page-item-tools-viewlive mr-1" :class="{ disabled: !showViewLiveCondition }" @mouseenter="mouseEnter" @mouseleave="mouseLeave" v-popover:tooltip.bottom="$t('generals.viewLivePage')" v-if="isViewLive()">
        <a :href="isOpenViewLive && page.viewliveUrl" target="_blank" class="page-item-tools-viewlive-button reset-button clickable">
          <i class="icon icon-view typo-icon-20 text-light-low" :class="[showViewLiveCondition ? 'text-light-low' : 'text-dark-high']"></i>
        </a>
      </div>
    </div>
    <!-- Check mark -->
    <div class="col-3 col-md-2 col-lg-1 col-mlg-2 col-xl-1 mh80 d-flex align-items-center" @click.stop="openEditor" v-else>
      <label class="checkmark-input">
        <input type="checkbox" name="checkbox[]" :value="page.id" v-model="isChecked" />
        <span class="checkmark"></span>
      </label>
    </div>
    <ModalUpgradePlan :page-type="pageType" @closeModalUpgradePlan="modalUpgradePlan = false" v-if="modalUpgradePlan" />
    <!-- Modal Make Live -->
    <Modal :hideExit="true" cClass="mw424" @cancel="closeModal" v-if="modelActive">
      <template #header>
        <p class="typo-heading20 typo-medium text-light-high">{{ titleModalMakeDefault }}</p>
      </template>
      <template #default>
        <!-- Body Make Default -->
        <template v-if="pageType == 'homepages'">
          <p class="typo-paragraph14 typo-regular-150 text-light-low make-default-text" v-html="$t('page.areYouSureMake', { name: titlePage })"></p>
        </template>
        <template v-else>
          <div class="gif-container mb-3">
            <img ref="gif" alt="visualize make default" v-if="modelActive" />
          </div>
          <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="makeDefaultText1"></p>
          <p class="typo-paragraph14 typo-regular-150 text-mono3">{{ makeDefaultText2 }}</p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse make-default-btn">
          <ProcessButton class="btn btn-primary ml-2" :status.sync="btnStatus" @click="handleMakeDefault" type="submit">
            <template #loading>{{ $t("generals.loading") }}...</template>
            <template #success>{{ $t("generals.success") }}</template>
            <template #error>{{ $t("generals.error") }}</template>
            <template #default>{{ titleModalMakeDefault }}</template>
          </ProcessButton>

          <button class="btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { PLAN_NO } from "@/contants/plan";
import ModalUpgradePlan from "@/core/components/ModalUpgradePlan";
let runnerEditor = null;
import { TimeMaker } from "@/plugins";
import PageItemDropdown from "./PageItemDropdown";
import { ProcessButton } from "@/core/shared";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import schedulePublish from "@/mixins/schedulePublish";
import ScheduleIcon from "../../ScheduleIcon.vue";
import AbTestingTooltip from "@/core/components/AbTestingTooltip.vue";

import checkGlobalConfigs from "@/mixins/checkGlobalConfigs.js";
import { HOME_PAGE_EVENT, PRODUCT_PAGE_EVENT, COLLECTION_PAGE_EVENT, PRODUCT_ASSIGNMENT_EVENT } from "@/config/constants/trackEventIds";
import { PAGE_DEFAULT_TITLE } from "@/contants/page";

const FREE_PLAN_LIMIT_PUBLISH_PAGE = 1;

export default {
  name: "GpListItem",
  components: {
    PageItemDropdown,
    ProcessButton,
    ScheduleIcon,
    AbTestingTooltip,
    ModalUpgradePlan
  },
  mixins: [schedulePublish("page"), checkGlobalConfigs()],
  props: {
    page: Object,
    type: {
      type: String,
      default: "row"
    },
    pageType: String,
    whereAmI: String,
    listType: String,
    templateList: [Object, Array],
    isChecked: Boolean,
    total: Number,
    loadingListRightSection: Boolean,
    img: String,
    isOpenRightSection: Boolean,
    currentPage: Number,
    pageDefaultTitle: String,
  },
  data() {
    return {
      modalUpgradePlan: false,
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      },
      descDefault: {
        "Theme Product Template": this.$t("page.shopifyProductTemplate"),
        "Theme Collection Template": this.$t("page.shopifyCollectionTemplate"),
        "Theme Index Template": this.$t("page.shopifyHomeTemplate"),
        "Your first Homepage": this.$t("page.shopifyHomeTemplate")
      },
      makeDefaultPages: ["template-collection", "template-index", "template-product"],
      originShopify: {
        image: "https://ucarecdn.com/d7cb7ae4-bd2a-4539-b838-5dbb071d5603/-/format/auto/-/preview/3000x3000/-/quality/lighter/"
      },
      modelActive: false,
      currentModel: "",
      childHovering: false,
      titleTooltip: false,
      campaignTooltip: false,
      groupTooltip: false,
      campaignDescTooltip: false,
      assigedDefaultTooltip: false,
      btnStatus: {
        success: false,
        loading: false,
        error: false
      }
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapState("page", {
      assignProductList: state => state.assignments.productpages.list,
      assignCollectionList: state => state.assignments.collectionpages.list,
      isAssignAllProducts: state => state.assignments.productpages.isAssignAll,
      isAssignAllCollections: state => state.assignments.collectionpages.isAssignAll,
      publishedPageCount: state => state.publishedPageCount
    }),
    ...mapGetters("page", {
      getAssignItems: "getAssignItems"
    }),
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapGetters("group", {
      groups: "groups"
    }),
    trial2022() {
      return this.shopInfo.plan === PLAN_NO.TRIAL2022;
    },
    publishedPagesCount() {
      return (this.shopInfo?.publishedPagesCount || 0) + this.publishedPageCount;
    },
    isDefaultPage() {
      return PAGE_DEFAULT_TITLE[this.page.title];
    },
    remainingDays() {
      return this.shopInfo?.remainingDays !== undefined && this.shopInfo?.remainingDays !== null ? this.shopInfo?.remainingDays : 30;
    },
    isOldTrial() {
      return this.shopInfo?.plan === PLAN_NO.TRIAL;
    },
    isExpired() {
      return this.remainingDays <= 0;
    },
    isShowMarkDefault() {
      const permission = this.shopInfo?.planLimitation[this.shopInfo?.plan] || {};

      if (this.trial2022 && this.publishedPagesCount === FREE_PLAN_LIMIT_PUBLISH_PAGE && this.page.is_published) {
        return true;
      }
      if (this.trial2022 && this.publishedPagesCount > FREE_PLAN_LIMIT_PUBLISH_PAGE) {
        return false;
      }
      if (this.publishedPagesCount >= permission.pagePublish?.nbOfPublishedPage) {
        return false;
      }
      if ((this.isOldTrial || this.trial2022) && this.isExpired) {
        return false;
      }

      return this.publishedPagesCount < permission.pagePublish?.nbOfPublishedPage || this.page.is_published || this.isDefaultPage;
    },
    makeDefaultTooltip() {
      if (this.isRunningAbTesting) {
        return this.$t("abTest.error1");
      }
      switch (this.page.type) {
        case "template-product":
          return this.$t("defaultPage.defaultProductPageTooltip");
        case "template-collection":
          return this.$t("defaultPage.defaultCollectionPageTooltip");
        default:
          return this.$t("generals.makeDefaultTooltip");
      }
    },
    eventHandler() {
      if (this.isOriginalShopifyPage || this.isRunningAbTesting || this.listType == "addPages") return "click";
      return null;
    },
    pageStatusClass() {
      if (["productpages", "collectionpages", "homepages"].includes(this.pageType)) {
        if (this.isDefault()) return "default";
        return;
      }
      if (this.isPublishScheduled) return "schedule";
      if (this.isNeedRepublishing) return "need-publish";
      if (!this.page.is_published) return "draft";
      return null;
    },
    pageStatus() {
      if (["productpages", "collectionpages", "homepages"].includes(this.pageType)) {
        if (this.isDefault()) return this.$t("generals.default");
        return;
      }
      if (this.isPublishScheduled) return this.$t("page.status.scheduled");
      if (this.isNeedRepublishing) return this.$t("page.status.outdated");
      if (!this.page.is_published) return this.$t("generals.draft");
      return null;
    },
    isEllipsisTitleActive() {
      if (!this.$refs.title) return;
      return this.$refs.title.offsetWidth < this.$refs.title.scrollWidth;
    },
    isTruncateGroupName() {
      const LIMIT_CHARACTER = 16;
      return this.groupName.length > LIMIT_CHARACTER;
    },
    isNeedRepublishing() {
      if (!this.page.is_published) return false;
      if (this.page.lastAction) return this.page.lastAction == "pageSave";
      return false;
    },
    isPublishScheduled() {
      if (!this.page.events) return false;
      return this.page.events.some(item => item.event == "schedule_publish");
    },
    isModifiedAt() {
      return ["homepages"].includes(this.pageType) || (["productpages", "collectionpages"].includes(this.pageType) && !this.isOpenRightSection) || (["subpages", "articlepages"].includes(this.pageType) && (!this.page.is_published || this.isNeedRepublishing));
    },
    schedulePublishAt() {
      if (!this.isPublishScheduled) return null;
      const scheduleEvent = this.page.events.find(item => item.event == "schedule_publish");
      const scheduledDate = new TimeMaker(scheduleEvent.event_at).ago(this.language);
      return `${this.$t("page.sort.scheduled")} ${scheduledDate}`;
    },
    isDisplayAssignedText() {
      if (this.listType != "productCollectionPages") return false;
      if (this.pageType != "productpages" && this.isOriginalShopifyPage) return false;
      if (this.pageType == "productpages") {
        if (this.isAssignAllProducts && this.page?.assigns?.length == 0) return false;
      }
      if (this.pageType == "collectionpages") {
        if (this.isAssignAllCollections && this.page?.assigns?.length == 0) return false;
      }
      return true;
    },
    isOpenViewLive() {
      if (["subpages", "articlepages"].includes(this.pageType)) {
        if (!this.page.is_published) return false;
      }
      if (this.page && this.page.viewliveUrl) {
        return true;
      }
      return false;
    },
    assignedTooltipText() {
      if (this.pageType == "productpages") {
        this.$t("page.default.assigned.tooltip");
      }
      return this.$t("page.default.assignedCollection.tooltip");
    },
    authorText() {
      if (this.pageType == "subpages") {
        if (this.page.author == null) {
          return {
            text:
              `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-half">
                      <path d="M12.404 3.92665C12.3963 3.85631 12.3337 3.82498 12.287 3.82498C12.2403 3.82498 11.217 3.74698 11.217 3.74698C11.217 3.74698 10.5063 3.03631 10.4203 2.96598C10.3423 2.88798 10.1937 2.91131 10.1313 2.92698C10.1237 2.92698 9.975 2.97398 9.733 3.05198C9.491 2.35665 9.077 1.72398 8.335 1.72398H8.26467C8.061 1.45831 7.79567 1.33331 7.577 1.33331C5.85867 1.33331 5.03067 3.48131 4.773 4.57498C4.10133 4.78598 3.62467 4.92631 3.57 4.94998C3.195 5.06698 3.18733 5.07498 3.14033 5.42631C3.10133 5.69198 2.125 13.245 2.125 13.245L9.725 14.6666L13.8493 13.7763C13.857 13.7606 12.412 3.99698 12.404 3.92665ZM9.311 3.16098C9.12367 3.21565 8.897 3.28598 8.67067 3.36398V3.22365C8.67067 2.80198 8.616 2.45831 8.51433 2.18465C8.90467 2.23165 9.147 2.66131 9.311 3.16098ZM8.03767 2.27065C8.13933 2.53631 8.20967 2.91131 8.20967 3.42665V3.50465C7.788 3.63731 7.34267 3.77031 6.88167 3.91865C7.13933 2.93465 7.63167 2.45031 8.03767 2.27065ZM7.53767 1.78631C7.61567 1.78631 7.694 1.81765 7.75633 1.86431C7.20167 2.12198 6.616 2.77031 6.37367 4.08265C6.00667 4.19965 5.655 4.30131 5.31933 4.41065C5.60067 3.41098 6.30367 1.78631 7.53767 1.78631Z" fill="#7CB342"/>
                      <path d="M12.2887 3.80932C12.2417 3.80932 11.2187 3.73132 11.2187 3.73132C11.2187 3.73132 10.508 3.02065 10.422 2.95032C10.3903 2.91899 10.3513 2.90332 10.3203 2.90332L9.75 14.6667L13.8743 13.7763C13.8743 13.7763 12.4293 3.99699 12.4213 3.92665C12.39 3.85632 12.3353 3.82499 12.2887 3.80932Z" fill="#558B2F"/>
                      <path d="M8.26283 6.1977L7.77117 7.6807C7.77117 7.6807 7.3255 7.44237 6.7955 7.44237C6.00417 7.44237 5.96583 7.9417 5.96583 8.0647C5.96583 8.7407 7.73283 9.00203 7.73283 10.5924C7.73283 11.8447 6.9415 12.6514 5.8735 12.6514C4.58283 12.6514 3.9375 11.8524 3.9375 11.8524L4.28317 10.7154C4.28317 10.7154 4.95917 11.2994 5.52783 11.2994C5.90417 11.2994 6.05783 11.0074 6.05783 10.7924C6.05783 9.9087 4.6135 9.87037 4.6135 8.4107C4.6135 7.18903 5.4895 6.00603 7.26417 6.00603C7.9245 5.99803 8.26283 6.1977 8.26283 6.1977Z" fill="white"/>
                    </svg>
                    ` +
              this.$t("empty.generals.fromShopify") +
              ` -&nbsp;`,
            class: "from-shopify d-flex align-item-center"
          };
        }
      }
      if (this.pageType == "articlepages") {
        if (this.page.author != "Shopify API") {
          return {
            text:
              `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-half">
                      <path d="M12.404 3.92665C12.3963 3.85631 12.3337 3.82498 12.287 3.82498C12.2403 3.82498 11.217 3.74698 11.217 3.74698C11.217 3.74698 10.5063 3.03631 10.4203 2.96598C10.3423 2.88798 10.1937 2.91131 10.1313 2.92698C10.1237 2.92698 9.975 2.97398 9.733 3.05198C9.491 2.35665 9.077 1.72398 8.335 1.72398H8.26467C8.061 1.45831 7.79567 1.33331 7.577 1.33331C5.85867 1.33331 5.03067 3.48131 4.773 4.57498C4.10133 4.78598 3.62467 4.92631 3.57 4.94998C3.195 5.06698 3.18733 5.07498 3.14033 5.42631C3.10133 5.69198 2.125 13.245 2.125 13.245L9.725 14.6666L13.8493 13.7763C13.857 13.7606 12.412 3.99698 12.404 3.92665ZM9.311 3.16098C9.12367 3.21565 8.897 3.28598 8.67067 3.36398V3.22365C8.67067 2.80198 8.616 2.45831 8.51433 2.18465C8.90467 2.23165 9.147 2.66131 9.311 3.16098ZM8.03767 2.27065C8.13933 2.53631 8.20967 2.91131 8.20967 3.42665V3.50465C7.788 3.63731 7.34267 3.77031 6.88167 3.91865C7.13933 2.93465 7.63167 2.45031 8.03767 2.27065ZM7.53767 1.78631C7.61567 1.78631 7.694 1.81765 7.75633 1.86431C7.20167 2.12198 6.616 2.77031 6.37367 4.08265C6.00667 4.19965 5.655 4.30131 5.31933 4.41065C5.60067 3.41098 6.30367 1.78631 7.53767 1.78631Z" fill="#7CB342"/>
                      <path d="M12.2887 3.80932C12.2417 3.80932 11.2187 3.73132 11.2187 3.73132C11.2187 3.73132 10.508 3.02065 10.422 2.95032C10.3903 2.91899 10.3513 2.90332 10.3203 2.90332L9.75 14.6667L13.8743 13.7763C13.8743 13.7763 12.4293 3.99699 12.4213 3.92665C12.39 3.85632 12.3353 3.82499 12.2887 3.80932Z" fill="#558B2F"/>
                      <path d="M8.26283 6.1977L7.77117 7.6807C7.77117 7.6807 7.3255 7.44237 6.7955 7.44237C6.00417 7.44237 5.96583 7.9417 5.96583 8.0647C5.96583 8.7407 7.73283 9.00203 7.73283 10.5924C7.73283 11.8447 6.9415 12.6514 5.8735 12.6514C4.58283 12.6514 3.9375 11.8524 3.9375 11.8524L4.28317 10.7154C4.28317 10.7154 4.95917 11.2994 5.52783 11.2994C5.90417 11.2994 6.05783 11.0074 6.05783 10.7924C6.05783 9.9087 4.6135 9.87037 4.6135 8.4107C4.6135 7.18903 5.4895 6.00603 7.26417 6.00603C7.9245 5.99803 8.26283 6.1977 8.26283 6.1977Z" fill="white"/>
                    </svg>
                    ` +
              this.$t("empty.generals.fromShopify") +
              ` -&nbsp;`,
            class: "from-shopify d-flex align-item-center"
          };
        }
      }
      return {
        text: "",
        class: ""
      };
    },
    makeDefaultText1() {
      let type = this.$tc("page.collectionLower", 2);
      if (this.pageType == "productpages") {
        type = this.$tc("page.productLower", 2);
      }
      // let title = (this.page && this.page.title) || "Default Template";

      let number = 0;
      this.templateList.forEach(e => {
        if (e.id != this.page.id) {
          if (e.published) {
            if (e.assigns && e.assigns.length) {
              e.assigns.forEach(el => {
                if (el.template_suffix && el.template_suffix.includes(e.id)) {
                  number++;
                }
              });
            }
          } else {
            if (e.assigns && e.assigns.length) {
              number += e.assigns.length;
            }
          }
        }
      });

      if (this.isBackToOriginal()) {
        return this.$t("page.backToOriginalText1", { type: type, number: number });
      }
      let text = this.$t("page.makeDefaultText1", { type: type });
      if (number) {
        text += this.$t("page.makeDefaultText11", { type: type, number: number });
      }
      return text;
    },
    makeDefaultText2() {
      let type = this.$tc("page.collectionLower", 2);
      if (this.pageType == "productpages") {
        type = this.$tc("page.productLower", 2);
      }
      return this.$t("page.makeDefaultText2", { type: type });
    },
    showViewLiveCondition() {
      if (!this.page.viewliveUrl) return false;
      if (["subpages", "articlepages", "homepages"].includes(this.pageType)) {
        return this.page.is_published;
      }
      return this.listType != "productCollectionPages";
    },
    timeago() {
      return new TimeMaker(this.page.updated_at).ago(this.language);
    },
    publishAgo() {
      return new TimeMaker(this.page.published_at).ago(this.language);
    },
    titleModal() {
      switch (this.currentModel) {
        case "duplicate":
          return this.$t("generals.duplicate");
        case "delete":
          return this.$t("generals.delete");
        case "settings":
          return this.$tc("generals.setting", 2);
      }
      return "";
    },
    groupName() {
      let group = this.groups(this.pageType).find(e => e.id == this.page.page_group_id);
      if (group) {
        return group.name;
      }
      return "";
    },
    titlePage() {
      if (this.isOriginalShopifyPage) {
        return this.textDefault[this.page.title];
      }
      return this.page.title;
    },
    descPage() {
      if (this.isOriginalShopifyPage) {
        return this.descDefault[this.page.title];
      }
      return "";
    },
    defaultText() {
      if (this.page.published == true) {
        return;
      } else {
        return this.$t("generals.makeDefault");
      }
    },
    titleModalMakeDefault() {
      return this.$t("generals.makeDefault");
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.page.title] ? true : false;
    },
    isRunningAbTesting() {
      return this.page.runningCampaignId > 0;
    },
    isMakeDefault() {
      return this.page.published;
    },
    itemCount() {
      let number = 0;

      if (!this.page.assigns || this.page.assigns.length == 0) {
        const assignProductNum = this.getAssignItems(this.pageType).filter(item => {
          if (item.template_suffix != null) {
            return item.template_suffix.includes(this.page.id);
          }
        });
        this.$set(this.page, "assigns", assignProductNum);
      }

      if (this.page.assigns != null) {
        number = this.page.assigns.filter(item => {
          if (item.template_suffix != null) {
            return item.template_suffix.includes(this.page.id);
          }
        }).length;
      }

      if (this.isDefault()) {
        if (this.pageType == "productpages") {
          return this.$t("page.default.assigned");
        }
        return this.$t("page.default.assignedCollections");
      }

      if (this.pageType == "productpages") {    
        const assignCount = this.page.assignmentCount ? this.page.assignmentCount : 0;
        return `Assigned ${assignCount} ${this.$tc("page.productLower", assignCount > 1 ? 2 : 1)}`;
      }

      if (number > 0) {
        const isAssignAll = number == this.assignCollectionList.length;
        isAssignAll ? this.updateCollectionAssignAll(true) : this.updateCollectionAssignAll(false);
        return `Assigned ${isAssignAll ? "all" : number} ${this.$tc("page.collectionLower", number == 1 ? 1 : 2)}`;
      }
      return `Assigned ${number} ${this.$tc("page.collectionLower", 1)}`;
    }
  },
  methods: {
    ...mapActions("page", {
      makeDefault: "makeDefault",
      fetchPages: "fetchPages",
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapMutations("page", {
      resetPageData: "RESET_PAGE_LIST",
      updateProductAssignAll: "UPDATE_ASSIGN_ALL_PRODUCT",
      updateCollectionAssignAll: "UPDATE_ASSIGN_ALL_COLLECTION"
    }),
    ...mapMutations("product", {
      resetProductAssignmentData: "RESET_PRODUCT_DATA",
    }),
    checkHover() {
      this.childHovering = true;
      this.$emit("hover", this.page);
      // if (this.page && this.page.__justUpdated) {
      //   console.log(this.page)
      //   this.page.__justUpdated = false;
      //   delete this.page.__justUpdated;
      //   console.log(this.page.__justUpdated)
      //   this.$forceUpdate();
      // }
      return;
    },
    checkLeave() {
      this.childHovering = false;
    },
    checkHoverTruncateABTestDesc() {
      this.$nextTick(() => {
        if (this.$refs.ab.offsetWidth < this.$refs.ab.scrollWidth) this.campaignDescTooltip = true;
      });
    },
    onMakeDefault(isBackToOriginal) {
      this.openModal(isBackToOriginal);
    },
    emitUpdate() {
      this.$emit("checkedUpdate", {
        id: this.page.id,
        value: this.isChecked
      });
    },
    getFileExtensionFromSource(src) {
      if (!src.includes(".")) return undefined;
      const lastItem = src.split(".").pop();
      if (!lastItem) return undefined;
      const extension = lastItem.split("?").shift();
      return extension;
    },
    onReLoadSearch() {
      this.$emit("onReLoadSearch");
    },
    isDefault() {
      if (this.layoutDefaultStatus()) {
        return this.page.published ? true : false;
      }
    },
    isViewLive() {
      if (this.pageType == "homepages") {
        return this.isDefault() ? true : false;
      }
      return this.listType != "productCollectionPages";
    },
    isBackToOriginal() {
      return this.textDefault[this.page.title] && this.page.published == false;
    },
    forceOpenEditor(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.isRunningAbTesting) return;
      if (this.page && !this.isOriginalShopifyPage) {
        this.$emit("openEditor", true);

        window.clearTimeout(runnerEditor);

        runnerEditor = window.setTimeout(() => {
          window.location.href = this.page.editUrl;
        }, 400);
      }
      return false;
    },
    openAssignSection() {
      this.$emit("openEditor", this.page);
      if ( this.pageType == 'productpages') {
        this.trackEvent({
          event_id: PRODUCT_ASSIGNMENT_EVENT.OPEN_ASSIGN_POPUP_FROM_PAGE_LIST,
          properties: {
            page_type: this.pageType,
            page_default: this.isDefault(),
            pagination: this.currentPage,
            template_page_id: this.page.id
          }
        });
      }
    },
    openEditor(e) {
      e.stopPropagation();
      e.preventDefault();

      if (this.isRunningAbTesting) return;

      // My Bad...v63
      if (this.listType == "addPages") {
        // Xu ly set value o dey ne @@
        this.isChecked = !this.isChecked;
        this.emitUpdate();
        return;
      }
      if (this.isOriginalShopifyPage) {
        this.$emit("preventOpenEditor", this.page);
      }
      if (this.page && !this.isOriginalShopifyPage) {
        this.$emit("openEditor", true);

        window.clearTimeout(runnerEditor);

        runnerEditor = window.setTimeout(() => {
          window.location.href = this.page.editUrl;
        }, 400);
      }
      return false;
    },
    layoutDefaultStatus() {
      return this.makeDefaultPages.includes(this.page.type) ? true : false;
    },
    imageURL() {
      if (this.isOriginalShopifyPage) {
        return this.originShopify.image;
      }
      return this.page.avatar;
    },
    async fetchPageData() {
      this.resetPageData();
      await this.fetchPages({ type: 'productpages' });
    },
    canMakeDefault() {
      return this.page.published == false || (this.textDefault[this.page.title] && this.page.published == false) ? true : false;
    },
    handleMakeDefault() {
      this.trackMakeDefaultEvent();

      // ===== Product Assignment Feature ===== //
      if (this.pageType === 'productpages') {
        this.resetProductAssignmentData();
      }
      // ====================================== //

      if (this.canMakeDefault()) {
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        this.btnStatus.loading = true;
        this.makeDefault({
          isTheme20: this.isKeyValid("theme20"),
          page: this.page,
          type: this.pageType,
          shop: this.shopInfo.shopifyDomain,
          onSuccess: async () => {
            this.gSnackbarCommit({
              message: this.$t("status.success"),
              type: "success"
            });
            this.btnStatus.true = true;
            this.$emit("makedDefault", this.page);
            await this.fetchPageData();
            this.closeModal();
          },
          onError: err => {
            // Show dialog
            let messageError = this.$t("status.error");
            // thêm try catch vì cấu trúc trả về lỗi đang lẫn cả cấu trúc mới cấu trúc cũ

            try {
              let errData = err.response.data;
              if (errData?.message == "belongToACampaign") {
                this.gDialogCommit({
                  type: "error",
                  message: "error.belongToACampaign",
                  data: {
                    id: errData?.data?.campaign?.id
                  }
                });
              }
              if (errData?.message) {
                //Nếu không phải belongToACampaign thì show translate lỗi
                messageError = this.$t(`error.${errData?.message}`);
              }
            } catch (error) {
              // lỗi thì kệ đã
            }

            this.gSnackbarCommit({
              message: messageError,
              type: "error"
            });
            this.btnStatus.error = true;
            this.closeModal();
          }
        });
      } else {
        this.closeModal();
      }
    },
    trackMakeDefaultEvent() {
      let eventId = null;

      switch (this.pageType) {
        case "homepages":
          eventId = HOME_PAGE_EVENT.MAKE_DEFAULT_CLICKED;
          break;
        case "collectionpages":
          eventId = COLLECTION_PAGE_EVENT.MAKE_DEFAULT_CLICKED;
          break;
        case "productpages":
          eventId = PRODUCT_PAGE_EVENT.MAKE_DEFAULT_CLICKED;
          break;
      }

      this.trackEvent({ event_id: eventId, properties: { template_page_id: this.page.id, text: this.$t("generals.makeDefault") } });
    },
    closeModalUpgradePlan() {
      this.modalUpgradePlan = false;
    },
    closeModal() {
      this.modelActive = false;
      if (this.$refs && this.$refs.gif) {
        this.$refs.gif.src = "";
      }
    },
    openModal(isBackToOriginal = false) {
      if (this.isDefaultPage) {
        this.modelActive = true;
        this.btnStatus = {
          success: false,
          loading: false,
          error: false
        };
        setTimeout(() => {
          this.refreshData();
        }, 0);
        return;
      }
      if (this.page.title !== "Theme Product Template" && !isBackToOriginal) {
        if (this.trial2022 && this.shopInfo.publishedPagesCount >= 1 && !this.page.is_published) {
          this.modalUpgradePlan = true;
          return;
        }

        const planLimitation = this.shopInfo?.developmentStore ? this.shopInfo?.planLimitation[this.shopInfo?.planDevelopmentStore] : this.shopInfo?.planLimitation[this.shopInfo?.plan];
        const nbOfPublishedProductPage = planLimitation ? planLimitation?.pagePublish?.nbOfPublishedProductPage : 10;
        if (this.pageType === "productpages" && this.shopInfo.plan === PLAN_NO.BUILD && this.shopInfo.publishedProductPagesCount >= nbOfPublishedProductPage && !this.page.is_published) {
          this.modalUpgradePlan = true;
          return;
        }
      }

      if (!this.isShowMarkDefault && !isBackToOriginal) {
        this.modalUpgradePlan = true;
        return;
      }

      if (this.isRunningAbTesting) {
        return;
      } else if (this.page.published != true) {
        this.modelActive = true;
        this.btnStatus = {
          success: false,
          loading: false,
          error: false
        };
        setTimeout(() => {
          this.refreshData();
        }, 0);
      }
    },
    getThumbnail(url) {
      let fileExtension = this.getFileExtensionFromSource(url);
      if (!fileExtension || url.includes("ThumbnailPlaceholder")) {
        return this.publicPath + require("@/core/assets/ThumbnailPlaceholder.jpg");
      }
      return url.slice(0, url.length - (fileExtension.length + 1)) + `_thumbnail.${fileExtension}`;
    },
    mouseEnter() {
      this.childHovering = true;
    },
    mouseLeave() {
      this.childHovering = false;
    },
    async refreshData() {
      if (this.$refs && this.$refs.gif) {
        this.$refs.gif.src = this.modelActive == false ? "" : this.img;
      }
    },
    preventOpenEditor(e) {
      this.$emit("preventOpenEditor", e);
    },
    imageLoadOnError() {
      this.page.thumbnail_url = this.publicPath + require("@/core/assets/ThumbnailPlaceholder.jpg");
    }
  }
};
</script>

<style lang="scss" scoped>
// Tiện thể ông lấy style của thg GpListItem này trong file style.scss vào đây rồi xoá style nó ở style.scss đi :v ok
// Quả GpListLoading fail vl :< vcl cái đấy đâu ra thế có à =)) ngày xưa anh Tiên viết mấy cái loading vào đấy =.=.
// Cai styles.scss dùng ở cả 3 file GpList.vue, GpListItem.vue, PageItemDropdown.vue nên thôi để nó vậy đi chứ copy vào toang đếy
.gif-container {
  overflow: hidden;
  width: 100%;
  img {
    width: calc(100% + 2px);
    transform: translate(-1px, -1px);
  }
}
.whitespace-nowrap {
  white-space: nowrap;
}

.tool-tip {
  padding: 8px;
  min-height: 30px;
  border-radius: 3px;
  background-color: $dark6;
  position: absolute;
  bottom: 150%;
  max-width: 1024px;
  width: max-content;
  left: 0;
  line-height: 150% !important;
  @media (max-width: 1660px) {
    max-width: 900px;
    span {
      line-height: 150% !important;
    }
  }
  @media (max-width: 1440px) {
    max-width: 700px;
    span {
      line-height: 150% !important;
    }
  }
  @media (max-width: 1136px) {
    max-width: 600px;
    span {
      line-height: 150% !important;
    }
  }
  &.side-bar-truncate {
    max-width: 680px;
    @media (max-width: 1660px) {
      max-width: 600px;
      span {
        line-height: 150% !important;
      }
    }
    @media (max-width: 1566px) {
      max-width: 400px;
      span {
        line-height: 150% !important;
      }
    }
    @media (max-width: 1136px) {
      max-width: 300px;
      span {
        line-height: 150% !important;
      }
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 25%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: $dark6 transparent transparent transparent;
  }
  &-assigned-default {
    width: 268px;
    left: 49% !important;
    transform: translateX(-49%) !important;
  }
  &-campaign {
    width: 300px;
  }
  &-campaign,
  &-assigned-default {
    height: 50px;
    font-size: 11px;
    margin-left: auto;
    margin-right: auto;
    left: 50%;
    transform: translateX(-50%);
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $dark6 transparent transparent transparent;
    }
    span {
      line-height: 150% !important;
    }
  }
  span {
    color: $light1;
    font-size: 11px;
    line-height: 14px;
  }
}
</style>
